export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';

export const TEMPLATES_INIT_STATE = null;
